export function isMemberImportExecutionResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const item = value;
    return (typeof item.batchId === 'string' &&
        item.status === 'completed' &&
        ['total', 'imported', 'preservedForReview'].every((key) => Number.isInteger(item[key])) &&
        typeof item.duplicateBlocked === 'boolean' &&
        typeof item.completedAt === 'string');
}
